import React, { useState } from "react";
import "../../styles/OurProducts.css";

const products = [
  {
    name: "T-Shirt",
    image: "assets/img/products/tshirt.webp",
  },
  {
    name: "Polo Shirt",
    image: "assets/img/products/polo-shirt.webp",
  },
  {
    name: "Jersey",
    image: "assets/img/products/jersey.webp",
  },
  {
    name: "Training",
    image: "assets/img/products/training.webp",
  },
  {
    name: "Hoodie/Jacket",
    image: "assets/img/products/hoodie-jacket.webp",
  },
  {
    name: "Kemeja",
    image: "assets/img/products/kemeja.webp",
  },
  {
    name: "Lanyard",
    image: "assets/img/products/lanyard.webp",
  },
  {
    name: "Topi",
    image: "assets/img/products/topi.webp",
  },
  {
    name: "Tote Bag",
    image: "assets/img/products/tote-bag.webp",
  },
];

const OurProducts = () => {
  const [showModal, setShowModal] = useState(false);
  const [activeImage, setActiveImage] = useState("");

  const handleImageClick = (imageUrl) => {
    setActiveImage(imageUrl);
    setShowModal(true);
    document.body.classList.add("modal-active");
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setActiveImage("");
    document.body.classList.remove("modal-active");
  };

  return (
    <section id="our-products" className="our-products container py-5">
      <div className="section-header" data-aos="fade-up" data-aos-delay="100">
        <h2>Our Products</h2>
      </div>
      <div className="row g-4 mt-2">
        {products.map((product, index) => (
          <div
            key={index}
            className="col-md-4 col-sm-6"
            data-aos="fade-up"
            data-aos-delay={100}
          >
            <div className="card product-card">
              <div
                className="image-container"
                onClick={() => handleImageClick(product.image)}
              >
                <img
                  src={product.image}
                  alt={product.name}
                  className="product-image"
                />
              </div>
              <div className="card-body d-flex flex-column justify-content-center">
                <h5 className="product-name">{product.name}</h5>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Modal */}
      {showModal && (
        <div className="modal-overlay" onClick={handleCloseModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            {/* Tombol Close */}
            <button className="close-button" onClick={handleCloseModal}>
              &times;
            </button>
            <img src={activeImage} alt="Product" className="modal-image" />
          </div>
        </div>
      )}
    </section>
  );
};

export default OurProducts;
